import { render, staticRenderFns } from "./PrePayHelp.vue?vue&type=template&id=31e337e8&scoped=true&"
import script from "./PrePayHelp.vue?vue&type=script&lang=js&"
export * from "./PrePayHelp.vue?vue&type=script&lang=js&"
import style0 from "./PrePayHelp.vue?vue&type=style&index=0&id=31e337e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e337e8",
  null
  
)

export default component.exports